/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: block;
}

.qds-divider {
  border: none;
  height: var(--qds-control-border-width);
  margin: 0;
  width: 100%;
}

.qds-vertical {
  height: 100%;
  width: var(--qds-control-border-width);
}

[data-importance='standard'] {
  background-color: var(--qds-theme-divider-standard);
}

[data-importance='emphasized'] {
  background-color: var(--qds-theme-divider-emphasized);
}

[data-importance='subdued'] {
  background-color: var(--qds-theme-divider-subdued);
}
